import * as React from 'react';
import { compose, pure } from 'recompose';

import { Omit } from '@material-ui/core';
import { createStyles, WithStyles, withStyles } from '@material-ui/styles';
import MenuItemMUI, { MenuItemProps as MenuItemMUIProps } from '@material-ui/core/MenuItem';

export interface SelectItemProps extends MenuItemMUIProps {
  label?: string;
  classes?: Partial<WithStyles<typeof styles>['classes']>;
}

interface SelectItemPrivateProps extends WithStyles<typeof styles, true>, Omit<SelectItemProps, 'classes'> {}

const styles = (theme: any) =>
  createStyles({
    root: {
      transition: 'all 50ms linear',
      '&:hover:not($selected)': {
        fontWeight: 'bold',
      },
    },
    selected: {
      fontWeight: 'bold',
      // backgroundColor: `${theme.color.primary.main} !important`,
      // color: `${theme.color.font.light} !important`,
    },
  });

const SelectItem: React.FC<SelectItemPrivateProps> = ({ theme, ...other }) => <MenuItemMUI {...(other as any)} />;

export default compose<SelectItemPrivateProps, SelectItemProps>(
  withStyles(styles, { withTheme: true }),
  pure,
)(SelectItem);
